module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-container"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5ab812b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ci-components/components/container.vue
// module id = 257
// module chunks = 4